import { render, staticRenderFns } from "./ficha.vue?vue&type=template&id=ea520c84&scoped=true&"
import script from "./ficha.vue?vue&type=script&lang=ts&"
export * from "./ficha.vue?vue&type=script&lang=ts&"
import style0 from "./ficha.vue?vue&type=style&index=0&id=ea520c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea520c84",
  null
  
)

export default component.exports